// Descriptions of Flowstep concepts, written for AI models. Shared by prompts
// and MCP tool descriptions so each concept is explained the same way everywhere.

export const SCREEN_JSX_DESCRIPTION = `A screen's JSX is a tree of elements. Each element has:
- a tag: an HTML element; a Shadcn component such as Button, Card, Input, or ChartContainer; a chart component such as BarChart or LineChart; or a Lucide icon
- attributes: className (Tailwind CSS classes) and other attributes, written on the tag
- children: nested elements or text, written between the opening and closing tags`;
